<template>
  <card :title="$t('your_password')">
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="update"
      @keydown="form.onKeydown($event)"
    >
      <v-col cols="12">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="form.password"
              :type="show ? 'text' : 'password'"
              name="password"
              label="Contraseña"
              placeholder=""
              :append-icon="show ? 'fa-eye' : 'fa-eye-slash'"
              counter
              maxlength="20"
              :rules="[rules.required, rules.format, rules.minLength, rules.maxLength, passwordConfirmationRule]"
              v-on="on"
              @click:append="show = !show"
            />
          </template>
          <span>
            La contraseña debe contener las siguientes características:<br>
            Longitud de 8 a 20 caracteres<br>
            Un caracter especial (!@#$&*_.-)<br>
            Un número<br>
            Una letra en mayúsculas<br>
          </span>
        </v-tooltip>
      </v-col>
      <v-col cols="12">
        <v-text-field

          v-model="form.password_confirmation"
          :type="confirmationShow ? 'text' : 'password'"
          name="password_confirmation"
          label="Confirmar contraseña"
          placeholder=""
          :append-icon="confirmationShow ? 'fa-eye' : 'fa-eye-slash'"
          counter
          maxlength="20"
          :rules="[rules.required, rules.format, rules.minLength, rules.maxLength, passwordConfirmationRule]"
          @click:append="confirmationShow = !confirmationShow"
        />
      </v-col>
      <v-col cols="12">
        <v-btn
          :loading="form.busy"
          :disabled="!valid || form.busy"
          class="mr-4"
          block
          color="success"
          @click="validate"
        >
          {{ $t('update') }}
        </v-btn>
      </v-col>
    </v-form>
  </card>
</template>

<script>
import Form from 'vform';

export default {
  scrollToTop: false,

  metaInfo() {
    return { title: this.$t('settings') };
  },

  data: () => ({
    valid: false,
    show: false,
    confirmationShow: false,
    rules: {
      required: (v) => !!v || 'La contraseña es requerida',
      format: (v) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*_.-])/.test(v) || 'La contraseña no es lo suficientemente segura',
      minLength: (v) => v.length >= 8 || 'La contraseña es muy corta',
      maxLength: (v) => v.length <= 20 || 'La contraseña es muy larga',
    },
    form: new Form({
      password: '',
      password_confirmation: '',
      busy: false,
    }),
  }),

  computed: {
    passwordConfirmationRule() {
      return this.form.password === this.form.password_confirmation || 'Las contraseñas deben coincidir';
    },
  },

  mounted() {
    this.valid = false;
  },

  methods: {
    async update() {
      await window.axios.patch('/api/settings/password', {
        password: this.form.password,
        password_confirmation: this.form.password_confirmation,
      }).then(() => {
        this.form.busy = false;
        this.$refs.form.reset();
      });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        this.update();
      }
    },
  },
};
</script>
